import {Injectable} from '@angular/core';
import {Beneficiaire} from '../../models/beneficiaire/beneficiaire.model';
import {BeneficiaireStorageService} from '../storage/beneficiaire-storage.service';

@Injectable()
export class BeneficiaireContextService {
    public constructor(
        private storage: BeneficiaireStorageService,
    ) {
    }

    /**
     * @returns {Beneficiaire | null}
     */
    public get(): Beneficiaire | null {
        return this.storage.get();
    }

    /**
     * @param {Beneficiaire} beneficiaire
     */
    public set(beneficiaire: Beneficiaire): void {
        this.storage.set(beneficiaire);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/context/beneficiaire-context.service.ts